import { useState, useEffect } from 'react';
import { FormGroup, Input, Textarea, Select } from '../components/Form';
import { getAgendadores, submitCadastroLead, getLeadSourcesConfig } from '../services/api';

const INITIAL = {
    nome: '',
    telefone: '',
    email: '',
    fonte: '',
    registradoPor: '',
    observacoes: '',
};

export default function CadastroLeads() {
    const [form, setForm] = useState(INITIAL);
    const [pessoas, setPessoas] = useState([]);
    const [fontes, setFontes] = useState([]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(null);
    const [error, setError] = useState(null);

    useEffect(() => {
        getAgendadores().then(setPessoas).catch(() => {});
        getLeadSourcesConfig().then((cfg) => { if (cfg) setFontes(Object.keys(cfg)); }).catch(() => {});
    }, []);

    const set = (field) => (e) => setForm((f) => ({ ...f, [field]: e.target.value }));

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setSuccess(null);
        if (!form.nome.trim()) return setError('Nome é obrigatório.');
        if (!form.fonte) return setError('Selecione a fonte do lead.');
        setLoading(true);
        try {
            const result = await submitCadastroLead(form);
            setSuccess(`Lead criado com sucesso! Contato: ${result.contactId}`);
            setForm(INITIAL);
        } catch (err) {
            setError(err.message || 'Erro ao cadastrar lead.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <div className="page-header">
                <div className="page-header-left">
                    <div>
                        <div className="page-kicker">Leads</div>
                        <h1 className="page-title">Cadastro de Lead</h1>
                    </div>
                </div>
            </div>

            <div className="page-body">
                {success && <div className="alert alert-success">{success}</div>}
                {error && <div className="alert alert-error">{error}</div>}

                <form onSubmit={handleSubmit}>
                    {/* Contato */}
                    <div className="card" style={{ marginBottom: '1.25rem' }}>
                        <p className="section-label">Dados do Contato</p>
                        <FormGroup label="Nome *" htmlFor="nome">
                            <Input id="nome" value={form.nome} onChange={set('nome')} placeholder="Nome completo do lead" required />
                        </FormGroup>
                        <div className="grid-2">
                            <FormGroup label="Telefone" htmlFor="telefone">
                                <Input id="telefone" value={form.telefone} onChange={set('telefone')} placeholder="Ex: 5511999998888" type="tel" />
                            </FormGroup>
                            <FormGroup label="E-mail" htmlFor="email">
                                <Input id="email" value={form.email} onChange={set('email')} placeholder="email@exemplo.com" type="email" />
                            </FormGroup>
                        </div>
                    </div>

                    {/* Origem */}
                    <div className="card" style={{ marginBottom: '1.25rem' }}>
                        <p className="section-label">Origem</p>
                        <div className="grid-2">
                            <FormGroup label="Fonte *" htmlFor="fonte">
                                <Select id="fonte" value={form.fonte} onChange={set('fonte')}>
                                    <option value="">Selecione a fonte</option>
                                    {fontes.map((f) => <option key={f} value={f}>{f}</option>)}
                                </Select>
                            </FormGroup>
                            <FormGroup label="Registrado por" htmlFor="registradoPor">
                                <Select id="registradoPor" value={form.registradoPor} onChange={set('registradoPor')}>
                                    <option value="">Selecione o responsável</option>
                                    {pessoas.map((p) => <option key={p.nome} value={p.nome}>{p.nome}</option>)}
                                </Select>
                            </FormGroup>
                        </div>
                    </div>

                    {/* Notas */}
                    <div className="card">
                        <p className="section-label">Notas</p>
                        <FormGroup label="Observações" htmlFor="observacoes">
                            <Textarea id="observacoes" value={form.observacoes} onChange={set('observacoes')} placeholder="Informações adicionais sobre o lead" rows={3} />
                        </FormGroup>
                        <div className="form-footer">
                            <button type="submit" className="pill pill-primary" disabled={loading}>
                                {loading ? 'Cadastrando...' : 'Cadastrar Lead'}
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        </>
    );
}
